import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import CarouselPage from "./CarouselPage"

// import images
import logodark from "../../assets/images/logo-dark.png"
import logolight from "../../assets/images/logo-light.png"
import { Col, Container, Row } from "reactstrap"
import { Link } from "react-router-dom"

export default class EmailVerification extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    return (
      <React.Fragment>
        <div>
          <MetaTags>
            <title>Email verification | Kattam</title>
          </MetaTags>
          <Container fluid className="p-0">
            <Row className="g-0">
              <CarouselPage />

              <Col cl={3}>
                <div className="auth-full-page-content p-md-5 p-4">
                  <div className="w-100">
                    <div className="d-flex flex-column h-100">
                      <div className="mb-4 mb-md-5">
                        <a href="/" className="d-block auth-logo">
                          <img
                            src={logodark}
                            alt=""
                            height="80"
                            className="auth-logo-dark"
                          />
                          <img
                            src={logolight}
                            alt=""
                            height="18"
                            className="auth-logo-light"
                          />
                        </a>
                      </div>
                      <div className="my-auto">
                        <div className="text-center">
                          <h4 className="text-success mb-md-4">
                            Successfully Registered!!!
                            </h4>
                          <div className="avatar-md mx-auto">
                            <div className="avatar-title rounded-circle bg-light">
                              <i className="bx bxs-envelope h1 mb-0 text-success"></i>
                            </div>
                          </div>
                          <div className="p-2 mt-4">
                            <h4>Verification email sent.</h4>
                            <p>
                              We have sent you verification email to {" "}
                              <span className="font-weight-semibold">
                                {this.props.location.email}
                              </span>
                              , Please click the link in the email to verify the account
                            </p>
                          </div>
                        </div>
                        <div className="mt-1 text-center">
                          <p>
                           Click here to{" "}
                                  <a href ="https://www.kattam.ai/product"
                                    className="fw-medium text-primary"
                                  >
                                    {" "}
                                    Home
                                  </a>{" "}Page
                          </p>
                        </div>
                      </div>
                      <div className="mt-4 mt-md-5 text-center">
                        <p className="mb-0">
                        Copyright © {new Date().getFullYear()} Kattam Intelligence Pte. Ltd. All rights reserved.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}
